export default "__VITE_ASSET__CZQP9kNn__"